import { FC } from 'react';
import { DataTestId } from '../layout/DataTestIdWrapper';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';
import { InfoColumn } from './styles';
import { CollectionInfoProps } from './types';
import { getMetaInfo } from './utils/getMetaInfo';
import { getStatus } from './utils/getStatus';

export const CollectionInfo: FC<CollectionInfoProps> = ({ collectionModel, menuItem }) => {
    if (!collectionModel) {
        return null;
    }

    const { displayName, modifiable, defaultCollection } = collectionModel;

    const metaInfo = getMetaInfo(collectionModel);

    return (
        <>
            <InfoColumn>
                <Flex direction="row">
                    <Typography
                        variant="title2"
                        weight="bold"
                        width="100%"
                        dataTestId={DataTestId.COLLECTION_NAME}
                        overflow="hidden"
                        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {displayName}
                    </Typography>
                    {menuItem}
                </Flex>
                {modifiable && !defaultCollection ? (
                    getStatus(collectionModel)
                ) : (
                    <Typography
                        variant="body"
                        color="secondary"
                        width="100%"
                        overflow="hidden"
                        style={{ textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                    >
                        {metaInfo}
                    </Typography>
                )}
            </InfoColumn>
        </>
    );
};
